import { useEffect, useRef, useState } from "react";

import logoBlueSvg from "../assets/images/logo_blue.svg";
import buttonHamburgerSvg from "../assets/images/icons/button_hamburger.svg";

import "../assets/css/product.scss";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();

  // 바깥 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <ul className="product-header">
      <li>
        <a href="/">
          <img src={logoBlueSvg} alt="" />
        </a>
      </li>

      <li className="menu">
        <div>
          <a href="/">어린이동아 소개</a>
        </div>
        <div className="on">
          <a href="/product">구독</a>
        </div>
        {/* <div>
          <a href="/">에듀클립</a>
        </div> */}
      </li>

      <li className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <img src={buttonHamburgerSvg} alt="" />
      </li>

      <li className={`mobile-slide-menu ${isOpen ? "open" : ""}`}>
        <div className="close-button" onClick={() => setIsOpen(false)}>
          &times;
        </div>
        <div>
          <a href="/">어린이동아 소개</a>
        </div>
        <div className="on">
          <a href="/product">구독</a>
        </div>
        {/* <div>
          <a href="/">에듀클립</a>
        </div> */}
      </li>

      {isOpen && <div className="overlay" onClick={() => setIsOpen(false)} />}
    </ul>
  );
}

export default Header;
